import React from "react";
import { HOMEHEALTH, TRACKER, USERLIST } from "../../../app/utils/Constants";
import Logo from "../../../components/layouts/Logo";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfile,
  profileList,
} from "../../landingPage/profile/operations/profileSlice";

export default function AccessStatus() {
  const dispatch = useDispatch();
  const profile = useSelector(profileList);
  React.useEffect(() => {
    dispatch(getProfile());
  }, []);

  React.useEffect(() => {
    if (profile && profile.status === "SUCCESS") {
      if (profile && profile.content) {
        localStorage.setItem(
          "userDetail",
          JSON.stringify(profile && profile.content)
        );
      }
      let permission = profile
        ? profile.content
          ? profile.content.permission || []
          : []
        : [];
      const mapPermission = permission.filter((perm) => perm.page === "map");
      const mapAccess =
        mapPermission.length === 1 ? mapPermission[0].access : [];
      const canViewMap =
        mapAccess &&
        mapAccess.find((item) => item === "spatial-features") ===
          "spatial-features"
          ? true
          : false;

      const homeHealthOrdersPermission = permission.filter(
        (perm) => perm.page === "home-health-orders"
      );
      const homeHealthAccess =
        homeHealthOrdersPermission.length === 1
          ? homeHealthOrdersPermission[0].access
          : [];
      const canViewHomeHealth =
        homeHealthAccess &&
        homeHealthAccess.find((item) => item === "list") === "list"
          ? true
          : false;

      setTimeout(() => {
        window.location.href = canViewMap
          ? TRACKER
          : canViewHomeHealth
          ? HOMEHEALTH
          : USERLIST;
      }, 1000);
    } else if (profile && profile.status === "ERROR") {
      setTimeout(() => {
        window.location.href = TRACKER;
      }, 1000);
    }
  }, [profile]);

  return (
    <React.Fragment>
      <Logo />
      <div
        data-testid="access-checkmark-circle"
        className="mb-15 auth-success-wrapper position-relative"
      >
        <span className="checkmark-with-circle auth-success success-info">
          <span className="visually-hidden">Checkmark with circle</span>
        </span>
      </div>
      <h1 className="mb-15 roboto-regular login-title">
        Authorization Granted!
      </h1>
      <p
        style={{ color: "#0D6E2B" }}
        className="mb-15 roboto-regular login-info"
      >
        You are successfully logged in. Please wait while we redirect you.
      </p>
    </React.Fragment>
  );
}
